<template>
  <div id="survey-dropdown">
    <p class="headline text-center">
      {{ $t("message.selectSurvey") }}
    </p>
    <v-select
      v-model="survey"
      :items="availableSurveys"
      return-object
      no-data-text="No surveys have been added"
      item-text="name"
      label="Survey"
      @change="setSurvey(survey)"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SurveySelectDropdown",
  data() {
    return {
      survey: null
    };
  },
  computed: {
    ...mapState({
      surveys: state => state.survey.surveys
    }),
    availableSurveys() {
      const programNameFromURL = this.$router.currentRoute.params.program_name;
      return this.surveys.filter(survey => {
        return (
          this.toUpperCase(survey.survey_metadata.meta_data.dashboardFiltering.program) ===
            this.toUpperCase(programNameFromURL.replace(/_/g, " ")) && survey.view_in_list
        );

      });
    }
  },
  methods: {
    setSurvey(survey) {
      this.$emit("set-survey", survey);
    },
    toUpperCase(name) {
      return (name).toUpperCase()
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#survey-dropdown {
  padding: 2%;
}
</style>
